import { PureComponent, HTMLProps, MouseEvent } from 'react';
import scrollTo, { TEasing } from '@tolkam/lib-scroll-to';

const DOC = document;
const HTML = DOC.documentElement;
const HISTORY = history;

class ScrollToTarget extends PureComponent<IProps, any> {

    /**
     * @inheritDoc
     */
    public static defaultProps: Partial<IProps> = {
        easing: 'easeInQuart',
        speed: 400,
    }

    /**
     * @inheritDoc
     */
    public componentDidMount() {
        // HISTORY.scrollRestoration = 'manual';
        addEventListener('popstate', this.onPopState);
    }

    /**
     * @inheritDoc
     */
    public componentWillUnmount() {
        removeEventListener('popstate', this.onPopState);
    }

    /**
     * @inheritDoc
     */
    public render() {
        const { props, onClick } = this;

        return <span
            dangerouslySetInnerHTML={{__html: props.children as string}}
            onClick={onClick}
        />;
    }

    /**
     * Handles popState event
     *
     * @param e
     */
    protected onPopState = (e: PopStateEvent) => {
        const props = this.props;
        const state = e.state;

        // restore previous scroll only
        if(state?.targetId === props.targetId && state?.previous) {
            scrollTo('Top', HTML, state.offset, props.speed, props.easing);
        }
    }

    /**
     * @param e
     */
    protected onClick = (e: MouseEvent) => {
        e.preventDefault();

        const that = this;
        const { targetId, speed, easing } = that.props;
        const target = DOC.getElementById(targetId);

        if(target) {
            const targetStyles = getComputedStyle(target) as any;
            const parentOffset = HTML.scrollTop;
            const offset = target.getBoundingClientRect().top
                + parentOffset
                - parseInt(targetStyles.scrollMarginTop);

            // store current scroll position
            HISTORY.replaceState({targetId, offset: parentOffset, previous: true}, '', '');

            scrollTo('Top', HTML, offset, speed, easing, () => {
                HISTORY.pushState({targetId, offset}, '', '');
            });
        }
    }
}

interface IProps extends HTMLProps<ScrollToTarget> {
    targetId: string;
    speed?: number,
    easing?: TEasing,
}

export default ScrollToTarget;
